import Navbar from '@/components/feature/Navbar';
import WhyChooseUsSection from '@/pages/home/components/WhyChooseUsSection';
import CTASection from '@/pages/home/components/CTASection';
import Footer from '@/components/feature/Footer';

export default function WhyUsPage() {
  return (
    <main>
      <Navbar />
      <div className="h-20"></div>
      <WhyChooseUsSection />
      <CTASection />
      <Footer />
    </main>
  );
}